core.directive('refundationStatus', ['$parse',
    function($parse) {
        var definition = {
            restrict: 'E',
            scope: {
                status: '=',
                showLabel: '@',
                checkEwusStatus: '&'
            },
            templateUrl: 'core/application/directive/refundationStatus/template/refundation-status.html',
            link: function($scope, element, attr) {
                if($scope.showLabel) {
                    $scope._showLabel = $scope.$eval($scope.showLabel);
                } else {
                    $scope._showLabel = true;
                }
                $scope.Enum = Enum;
            }
        };

        return definition;
    }
]);